module.exports = __webpack_public_path__ + "static/media/RECLAMACIONES.682cc488.svg";